const Style = {
    // Used only by ProjectAuthLayout, which shares this file: `contents` keeps
    // the BrandScope wrapper from becoming a box between the viewport and the
    // shell, so min-h-screen still measures against the viewport.
    scope: 'contents',
    shell: 'flex min-h-screen',
    branding:
        'relative hidden w-[40%] flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-primary-800 to-primary-900 p-12 lg:flex',
    brandingCopy: 'relative z-10 max-w-md text-center',
    // /assets/icon.png is ~1.4:1 — `w-auto`, not a square `w-16`, or it squashes.
    logo: 'mx-auto mb-8 h-16 w-auto',
    brandTitle: 'mb-4 text-3xl font-bold text-white',
    brandTagline: 'text-lg text-primary-200',
    formPanel:
        'relative flex flex-1 flex-col items-center justify-center bg-background p-6 sm:p-12',
    themePin: 'absolute right-4 top-4',
    formInner: 'w-full max-w-md',
    // ProjectAuthLayout only — the attribution pinned under the form panel.
    attribution:
        'absolute bottom-6 text-xs text-text-muted no-underline underline-offset-4 hover:text-text-secondary hover:underline',
};

export default Style;
